import ProposalAPI from 'dashboard/api/proposals';
import { createStore } from 'dashboard/store/storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';

const upsert = (store, record) => {
  const index = store.records.findIndex(r => r.id === record.id);
  if (index === -1) store.records.push(record);
  else store.records[index] = record;
};

export const useProposalsStore = createStore({
  name: 'proposals',
  type: 'pinia',
  API: ProposalAPI,

  actions: () => ({
    async sendEmail(id) {
      this.setUIFlag({ sendingEmail: true });
      try {
        const {
          data: { payload },
        } = await ProposalAPI.sendEmail(id);
        upsert(this, payload);
        return payload;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        this.setUIFlag({ sendingEmail: false });
      }
    },

    async sendWhatsapp(id) {
      this.setUIFlag({ sendingWhatsapp: true });
      try {
        const {
          data: { payload },
        } = await ProposalAPI.sendWhatsapp(id);
        upsert(this, payload);
        return payload;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        this.setUIFlag({ sendingWhatsapp: false });
      }
    },

    // Not persisted, so nothing is upserted into records - just returns the
    // calculator's own breakdown for the caller to render.
    async previewPricing(proposal) {
      this.setUIFlag({ previewingPricing: true });
      try {
        const { data } = await ProposalAPI.preview(proposal);
        return data;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        this.setUIFlag({ previewingPricing: false });
      }
    },
  }),
});
